import React from 'react';
import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import ExclusiveListingsJpg from '../exclusiveListings/exclusive-listings.jpg';
import ExclusiveListingsWebp from '../exclusiveListings/exclusive-listings.webp';
import ExclusiveListingsMobileJpg from '../exclusiveListings/exclusive-listings_mobile.jpg';
import ExclusiveListingsMobileWebp from '../exclusiveListings/exclusive-listings_mobile.webp';
import { useGetHasProduct } from '../../../../../customHooks/useGetHasProduct.hook';
import { ProductType } from '../../../../../@types/product';
import { Msg, useIntl } from '@/i18n';
import { FAQTab } from '@/components/common/display/faqTab/FAQTab';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = () => {
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.exclusiveListingsMieterPlus.modal.overview.paragraph1'
          defaultMessage='"Exclusive listings" come from...'
        />
      </div>
      {!isEntitledPlusRent && (
        <ul className='list-check list-spacing-s'>
          <li data-testid='mieter-plus-label-with-checkmark'>
            <Msg
              id='benefits.exclusiveListingsMieterPlus.modal.overview.activeMieterPlus'
              defaultMessage='Keep Mieter Plus...'
              values={{
                MieterPlusLogo: <PlusBadge variant='rent' />,
              }}
            />
          </li>
        </ul>
      )}
    </div>
  );
};

const ButtonArea = () => {
  return (
    <div className='align-center'>
      <a
        className='button-secondary button-rounded'
        href='/meinkonto/premium-mitgliedschaft/?cmp_id=10-051526&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=exclusive_listings_cta'
      >
        <Msg id='benefits.exclusiveListingsMieterPlus.modal.linkButton' defaultMessage='Discover Mieter Plus' />
      </a>
    </div>
  );
};

export const ExclusiveListingsMieterPlus = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);

  return (
    <Modal
      title={t({ id: 'benefits.exclusiveListingsMieterPlus.headline', defaultMessage: 'Exclusive listings' })}
      isVisible={isVisible}
      image={ExclusiveListingsJpg}
      imageWebp={ExclusiveListingsWebp}
      imageMobile={ExclusiveListingsMobileJpg}
      imageMobileWebp={ExclusiveListingsMobileWebp}
      imageUseFullWidth={false}
      imageAlt={t({ id: 'benefits.exclusiveListingsMieterPlus.modal.image', defaultMessage: 'Phone with preview' })}
      tabsContent={[
        <OverviewTab key='benefits.exclusiveListingsMieterPlus.modal.overview' />,
        <FAQTab key='benefits.exclusiveListingsMieterPlus.modal.faq' benefit='exclusiveListingsMieterPlus' />,
      ]}
      benefit={Benefit.ADVERTISEMENTS}
      buttonArea={!isEntitledPlusRent ? <ButtonArea /> : null}
      onClose={onClose}
    />
  );
};
